import {config} from '../../utils.js';
const EVENT_PURCHASE = 'event-purchase';
const purchaseEventTrigger = () => {
  const isCheckoutConfirm = config.section === 'checkout' &&
      config.page === 'confirm';
  if (isCheckoutConfirm) {
    const event = new CustomEvent(EVENT_PURCHASE);
		document.dispatchEvent(event);
  }
};

export {EVENT_PURCHASE, purchaseEventTrigger};